import styled from "styled-components";

export const StyledInput = styled.input`
	border: 1px solid #c0c4df;

	height: 2.5rem;
	width: 100%;

	border-radius: 0.25rem;

	transition: border 0.2s;

	padding: 0 0.5rem;

	font-size: 1.2rem;
	font-family: "Mulish";

	&::placeholder {
		color: #c0c4df;

		font-size: 1.2rem;
		font-family: "Roboto";
		font-weight: 300;

		line-height: 28px;
	}
	&:focus {
		border: 1px solid #2d7bbc;

		color: #2d7bbc;

		::placeholder {
			color: #2d7bbc;
		}
	}
`;
